






































import { Component, Vue, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import Loading from '@/components/Loading.vue';
import store from '@/store';

@Component({
  components: {
    Loading,
  },
})
export default class CenterList extends Vue {
  @Prop({ required: false, default: false })
  public adminVersion?: boolean;

  get centersQuery() {
    return gql`
      query Centers {
        centers {
          id
          centerCode
          name
        }

        user {
          id
          role
          centers {
            id
            isAdmin
            centerId
          }
        }
      }
    `;
  }
  public onCenterClicked(center: any) {
    this.$emit('centerSelected', center.id, center.centerCode);
  }

  public centerImage(center: any) {
    try {
      return require(`@/assets/centers/${center.centerCode}/logo.png`);
    } catch (e) {
      return null;
    }
  }

  // Computed property that returns a sorting function.
  // This allows the template to call `sortedCenters(data.centers)` without sorting inline.
  public filteredSortedCenters(centers: any, user: any) {
    if (!centers || !Array.isArray(centers)) { return []; }

    const userRole = user ? user.role.toLowerCase() : null;
    const filteredCenters = !userRole || userRole === 'system_admin' || !this.adminVersion
      ? centers
      : centers.filter((center: any) => user.centers.some((c: any) => c.isAdmin && c.centerId === center.id)) ;

    return filteredCenters.slice().sort((a: any, b: any) => {
      const na = a && a.name ? String(a.name) : '';
      const nb = b && b.name ? String(b.name) : '';
      return na.localeCompare(nb, undefined, { sensitivity: 'base' });
    });
  }
}
